// extracted by mini-css-extract-plugin
module.exports = {"container":"Index_container__A6RWB"};